/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,.' + accBtn + '-close,#overlay').toggleClass('active')
    scrollLock('html,body', '#overlay')
  })

  /*
  ######  ##        #######   ######  ########
 ##    ## ##       ##     ## ##    ## ##
 ##       ##       ##     ## ##       ##
 ##       ##       ##     ##  ######  ######
 ##       ##       ##     ##       ## ##
 ##    ## ##       ##     ## ##    ## ##
  ######  ########  #######   ######  ########
*/
  $('#modalOverlay').on('click', function() {
    $('#modalOverlay,.js-modal').removeClass('active')
    if (!$('#overlay').hasClass('active')) {
      scrollLock('html,body', '#modalOverlay')
    }
  })

  /*
        ######   ######          ########    ###    ########  ######## #### ##    ##
       ##    ## ##    ##         ##         ## ##   ##     ## ##        ##  ###   ##
       ##       ##               ##        ##   ##  ##     ## ##        ##  ####  ##
        ######  ##       ####### ######   ##     ## ##     ## ######    ##  ## ## ##
             ## ##               ##       ######### ##     ## ##        ##  ##  ####
       ##    ## ##    ##         ##       ##     ## ##     ## ##        ##  ##   ###
        ######   ######          ##       ##     ## ########  ######## #### ##    ##
*/

  // スクロール量による切り替え要素　負荷を抑えるためFPS制で処理する
  const scToggleFps = 5 // 1秒間の判定回数 60FPSまで上げるとほとんど負荷低減効果がなくなる
  const scToggleFrameTime = 1000 / scToggleFps
  let scToggleIsScroll = false // スクロールフラグ
  let scToggleScrollY = 0 // 縦方向のスクロール量
  let scTogglePx = 500 // スクロール半定ライン
  const scToggleTarget = document.querySelectorAll('#header') // ターゲット要素
  const scToggleClass = 'active' // スイッチ用クラス
  let scToggleSwitch = false // ターゲット要素のONOFF状態

  let scLock = false // スクロールロックがかかっているかの判定

  // 負荷テスト用
  // let scToggleScrollCount = 0
  // let scToggleSctionCount = 0
  document.addEventListener('scroll', function(ev) {
    // スクロール量の更新だけを行う
    scToggleScrollY = window.pageYOffset // スクロール量更新
    scToggleIsScroll = true // フラグON
    // console.log('Scroll:' + ++scToggleScrollCount)
  })
  scrollFadein()
  function scrollFadein() {
    // スクロールフラグが立っており、ロックされていないときだけDOM書き換え
    if (scToggleIsScroll && !scLock) {
      if (scToggleScrollY >= scTogglePx && !scToggleSwitch) {
        //トップから指定px以上スクロールしたらON
        scToggleTarget[0].classList.add(scToggleClass)
        // console.log('Action:' + ++scToggleSctionCount)
        scToggleSwitch = true
      } else if (scToggleScrollY < scTogglePx && scToggleSwitch) {
        //スクロールが足りない時はOFF
        scToggleTarget[0].classList.remove(scToggleClass)
        scToggleSwitch = false
        // console.log('Action:' + ++scToggleSctionCount)
      }
      scToggleIsScroll = false // スクロールフラグをOFFに戻す
    }
    setTimeout(scrollFadein, scToggleFrameTime) // 次回の処理を登録
  }

  /*
    ######   ######          ##        #######   ######  ##    ##
   ##    ## ##    ##         ##       ##     ## ##    ## ##   ##
   ##       ##               ##       ##     ## ##       ##  ##
    ######  ##       ####### ##       ##     ## ##       #####
         ## ##               ##       ##     ## ##       ##  ##
   ##    ## ##    ##         ##       ##     ## ##    ## ##   ##
    ######   ######          ########  #######   ######  ##    ##
  */
  /**
   * Safariを含めた全ブラウザでスクロールをロックする
   * オーバーレイの状態を基準にONOFFを切り替え
   * scrollLock('html,body', '#overlay')
   *
   * @function scrollLock
   * @param  {String} [selecter='html,body']  固定対象セレクタ
   * @param  {String} [trigger='#overlay']  判定用セレクタ
   * @return {Boolean} false
   */
  let scrollTop
  function scrollLock(selecter = 'html,body', trigger = '#overlay') {
    if ($(trigger).hasClass('active')) {
      // スクロール停止
      scrollTop = $(window).scrollTop()
      $(selecter).css({ position: 'fixed', top: -scrollTop })
      scLock = true
    } else {
      // スクロール停止解除
      $(selecter).css({ position: 'static', top: '0' })
      $(selecter).scrollTop(scrollTop)
      scLock = false
    }
  }

  /*
       ######## ########  ##     ## ##    ## ##    ##  #######
          ##    ##     ## ##     ## ###   ## ##   ##  ##     ##
          ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
          ##    ########  ##     ## ## ## ## #####     #######
          ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
          ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
          ##    ##     ##  #######  ##    ## ##    ##  #######
*/
  function trunk8() {
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }
  if ($('.js-t8')[0]) {
    // 要素を検出したら実行
    trunk8()
    $(window).on('load resize ', function() {
      trunk8()
    })
  }

  /*
        ######  ##       #### ########  ########
       ##    ## ##        ##  ##     ## ##
       ##       ##        ##  ##     ## ##
        ######  ##        ##  ##     ## ######
             ## ##        ##  ##     ## ##
       ##    ## ##        ##  ##     ## ##
        ######  ######## #### ########  ########
*/
  if ($('#mv-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const mvSwiper = new Swiper('#mv-slide', {
      // init: false, // 自動で初期化しない（mvSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      grabCursor: true, // 掴みカーソル
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      autoplay: {
        // オートオプション
        delay: 3000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      }
    })
  }

  if ($('#special-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const specialSwiper = new Swiper('#special-slide', {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 2, //表示数変更
      spaceBetween: 20, //スライド同士の間隔を空ける
      // centeredSlides: true, // 中央のスライドを基準にする
      // freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      // grabCursor: true, // 掴みカーソル
      //    simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      //    autoHeight: true, // スライドごとに高さを変動させる
      autoplay: { delay: 5000 },
      navigation: {
        nextEl: '.swiper-button-next--special', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--special' // 次のページボタンを呼び出す要素
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        // 指定px以下時にオプション切り替え
        768: {
          slidesPerView: 1 //表示数変更
        }
      }
    })
  }

  /*
  #######  ########  ######## ##    ##         ######## ##    ## ########  ########
 ##     ## ##     ## ##       ###   ##            ##     ##  ##  ##     ## ##
 ##     ## ##     ## ##       ####  ##            ##      ####   ##     ## ##
 ##     ## ########  ######   ## ## ## #######    ##       ##    ########  ######
 ##     ## ##        ##       ##  ####            ##       ##    ##        ##
 ##     ## ##        ##       ##   ###            ##       ##    ##        ##
  #######  ##        ######## ##    ##            ##       ##    ##        ########
*/
  $('.js-typeModal').on('click', '.js-typeModal--btn,.js-typeModal--close', function() {
    $(this)
      .parent('.js-typeModal')
      .find('.js-typeModal--body')
      .toggleClass('active')
  })

  /*
        ######  ##       ####  ######  ##    ##            ###    ########  ########
       ##    ## ##        ##  ##    ## ##   ##            ## ##   ##     ## ##     ##
       ##       ##        ##  ##       ##  ##            ##   ##  ##     ## ##     ##
       ##       ##        ##  ##       #####    ####### ##     ## ##     ## ##     ##
       ##       ##        ##  ##       ##  ##           ######### ##     ## ##     ##
       ##    ## ##        ##  ##    ## ##   ##          ##     ## ##     ## ##     ##
        ######  ######## ####  ######  ##    ##         ##     ## ########  ########
*/
  $(document).on(' click ', '.js-clickData', function() {
    const target = $(this).data('target')
    const text = $(this).data('text')
    const val = $(this).data('val')
    $('.js-text--' + target)
      .text(text)
      .addClass('active')
    $('.js-input-' + target).val(val)
  })

  /*
  #######  ########  ######## ##    ##         ##     ##  #######  ########     ###    ##
 ##     ## ##     ## ##       ###   ##         ###   ### ##     ## ##     ##   ## ##   ##
 ##     ## ##     ## ##       ####  ##         #### #### ##     ## ##     ##  ##   ##  ##
 ##     ## ########  ######   ## ## ## ####### ## ### ## ##     ## ##     ## ##     ## ##
 ##     ## ##        ##       ##  ####         ##     ## ##     ## ##     ## ######### ##
 ##     ## ##        ##       ##   ###         ##     ## ##     ## ##     ## ##     ## ##
  #######  ##        ######## ##    ##         ##     ##  #######  ########  ##     ## ########
*/
  $(document).on('click ', '.js-modal--btn', function() {
    const target = $(this).data('target')
    $('.js-modal--' + target).addClass('active')
    $('#modalOverlay').addClass('active')

    if (!$('#overlay').hasClass('active')) {
      scrollLock('html,body', '#modalOverlay')
    }
  })

  /*
       ########    ###    ########
          ##      ## ##   ##     ##
          ##     ##   ##  ##     ##
          ##    ##     ## ########
          ##    ######### ##     ##
          ##    ##     ## ##     ##
          ##    ##     ## ########
*/
  $('.tab-area').each(function() {
    const btn = $(this).find('.tab-btn')
    const item = $(this).find('.tab-item')
    btn.on('click', function() {
      const index = $(this)[0].dataset.tab // data-tab属性から対応アイテムのセレクタを取得
      btn.removeClass('active') // activeを全て解除
      item.removeClass('active') // activeを全て解除
      $(this).addClass('active')
      $(index).addClass('active')
    })
  })

  /*
  ######  ##     ## ########  ######  ##    ##
 ##    ## ##     ## ##       ##    ## ##   ##
 ##       ##     ## ##       ##       ##  ##
 ##       ######### ######   ##       #####
 ##       ##     ## ##       ##       ##  ##
 ##    ## ##     ## ##       ##    ## ##   ##
  ######  ##     ## ########  ######  ##    ##
*/

  $('.js-check').on('change', function() {
    const target = $(this).data('target')
    let viewText = ''
    let hiddenData = ''
    let count = 1

    // 同一の値のチェックボックスの同期処理
    const checkSyncVal = $(this).val()
    const chackSyncFlag = $(this).prop('checked')
    $('.js-check--' + target).each(function() {
      if ($(this).val() === checkSyncVal) {
        if (chackSyncFlag) {
          $(this).prop('checked', true)
        } else {
          $(this).prop('checked', false)
        }
      }
    })

    // 値を検索項目として反映する処理

    const textView = $('.js-text--' + target)
    const hiddenPool = $('.js-hiddenPool--' + target)
    textView.text('')
    hiddenPool.html('')

    $('.js-check--' + target + '--origin').each(function() {
      if ($(this).prop('checked')) {
        const text = $(this).data('name')
        const val = $(this).val()

        if (count !== 1) {
          viewText = viewText + ', '
        }

        viewText += text
        hiddenData += '<input type="hidden" name="' + target + '[]" value="' + val + '">'
        ++count
      }
    })
    if (viewText === '') {
      viewText = textView.data('def')
    }
    textView.text(viewText)
    hiddenPool.html(hiddenData)
  })
})
